import SearchAPI from '../../api/search';
import types from '../mutation-types';
export const initialState = {
  records: [],
  contactRecords: {
    summary: [],
    results: [],
  },
  conversationRecords: {
    summary: [],
    results: [],
  },
  messageRecords: {
    summary: [],
    results: [],
  },
  uiFlags: {
    isFetching: false,
    isSearchCompleted: false,
    contact: { isFetching: false, isFetchingSummary: false },
    conversation: { isFetching: false, isFetchingSummary: false },
    message: { isFetching: false, isFetchingSummary: false},
  },
};

export const getters = {
  getConversations(state) {
    return state.records;
  },
  getContactRecords(state) {
    return state.contactRecords.results;
  },
  getContactSummaryRecords(state) {
    return state.contactRecords.summary;
  },
  getConversationRecords(state) {
    return state.conversationRecords.results;
  },
  getConversationSummaryRecords(state) {
    return state.conversationRecords.summary;
  },
  getMessageRecords(state) {
    return state.messageRecords.results;
  },
  getMessageSummaryRecords(state) {
    return state.messageRecords.summary;
  },
  getUIFlags(state) {
    return state.uiFlags;
  },
};

export const actions = {
  async get({ commit }, { q }) {
    commit(types.SEARCH_CONVERSATIONS_SET, []);
    if (!q) {
      return;
    }
    commit(types.SEARCH_CONVERSATIONS_SET_UI_FLAG, { isFetching: true });
    try {
      const {
        data: { payload },
      } = await SearchAPI.get({ q });
      commit(types.SEARCH_CONVERSATIONS_SET, payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SEARCH_CONVERSATIONS_SET_UI_FLAG, {
        isFetching: false,
      });
    }
  },
  async fullSearch({ commit, dispatch }, { q }) {
    if (!q) {
      return;
    }
    commit(types.FULL_SEARCH_SET_UI_FLAG, {
      isFetching: true,
      isSearchCompleted: false,
    });
    try {
      await Promise.all([
        dispatch('contactSearch', { q }),
        dispatch('conversationSearch', { q }),
        dispatch('messageSearch', { q }),
      ]);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.FULL_SEARCH_SET_UI_FLAG, {
        isFetching: false,
        isSearchCompleted: true,
      });
    }
  },
  async contactSearch({ commit }, q) {
    commit(types.CONTACT_SEARCH_SET, { results: [] });
    commit(types.CONTACT_SEARCH_SET_UI_FLAG, { isFetching: true });
    try {
      const { data } = await SearchAPI.contacts(q);
      commit(types.CONTACT_SEARCH_SET, { results: data.payload.contacts });
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.CONTACT_SEARCH_SET_UI_FLAG, { isFetching: false });
    }
  },
  async contactSearchSummary({ commit }, q) {
    commit(types.CONTACT_SEARCH_SET, { summary: [] });
    commit(types.CONTACT_SEARCH_SET_UI_FLAG, { isFetchingSummary: true });
    try {
      const { data } = await SearchAPI.contacts({ ...q, summary: true });
      commit(types.CONTACT_SEARCH_SET, { summary: data.payload });
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.CONTACT_SEARCH_SET_UI_FLAG, { isFetchingSummary: false });
    }
  },
  async conversationSearch({ commit }, q ) {
    commit(types.CONVERSATION_SEARCH_SET, { results: [] });
    commit(types.CONVERSATION_SEARCH_SET_UI_FLAG, { isFetching: true });
    try {
      const { data } = await SearchAPI.conversations(q);
      commit(types.CONVERSATION_SEARCH_SET, {
        results: data.payload.conversations,
      });
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.CONVERSATION_SEARCH_SET_UI_FLAG, { isFetching: false });
    }
  },
  async conversationSearchSummary({ commit }, q) {
    commit(types.CONVERSATION_SEARCH_SET, { summary: [] });
    commit(types.CONVERSATION_SEARCH_SET_UI_FLAG, { isFetchingSummary: true });
    try {
      const { data } = await SearchAPI.conversations({ ...q, summary: true });
      commit(types.CONVERSATION_SEARCH_SET, { summary: data.payload });
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.CONVERSATION_SEARCH_SET_UI_FLAG, {
        isFetchingSummary: false,
      });
    }
  },
  async messageSearch({ commit }, q ) {
    commit(types.MESSAGE_SEARCH_SET, {results: []});
    commit(types.MESSAGE_SEARCH_SET_UI_FLAG, { isFetching: true });
    // Sem catch: o erro é repassado para a tela exibir a mensagem retornada pela API
    try {
      const { data } = await SearchAPI.messages(q);
      commit(types.MESSAGE_SEARCH_SET, {results: data.payload.messages});
    } finally {
      commit(types.MESSAGE_SEARCH_SET_UI_FLAG, { isFetching: false });
    }
  },
  async messageSearchSummary({ commit }, q ) {
    commit(types.MESSAGE_SEARCH_SET, {summary: []});
    commit(types.MESSAGE_SEARCH_SET_UI_FLAG, { isFetchingSummary: true });
    // Sem catch: o erro é repassado para a tela exibir a mensagem retornada pela API
    try {
      const { data } = await SearchAPI.messages({...q, summary: true});
      commit(types.MESSAGE_SEARCH_SET, {summary: data.payload});
    } finally {
      commit(types.MESSAGE_SEARCH_SET_UI_FLAG, { isFetchingSummary: false });
    }
  },
  async clearSearchResults({ commit }, {type}) {
    if(!type || type == 'all' || type == 'contact'){
      commit(types.CONTACT_SEARCH_SET, { summary: [], results: [] });
    }
    if(!type || type == 'all' || type == 'conversation'){
      commit(types.CONVERSATION_SEARCH_SET, { summary: [], results: [] });
    }
    if(!type || type == 'all' || type == 'message'){
      commit(types.MESSAGE_SEARCH_SET, { summary: [], results: [] });
    }
  },
};

export const mutations = {
  [types.SEARCH_CONVERSATIONS_SET](state, records) {
    state.records = records;
  },
  [types.CONTACT_SEARCH_SET](state, records) {
    state.contactRecords = { ...state.contactRecords, ...records };
  },
  [types.CONVERSATION_SEARCH_SET](state, records) {
    state.conversationRecords = { ...state.conversationRecords, ...records };
  },
  [types.MESSAGE_SEARCH_SET](state, records) {
    state.messageRecords = { ...state.messageRecords, ...records };
  },
  [types.SEARCH_CONVERSATIONS_SET_UI_FLAG](state, uiFlags) {
    state.uiFlags = { ...state.uiFlags, ...uiFlags };
  },
  [types.FULL_SEARCH_SET_UI_FLAG](state, uiFlags) {
    state.uiFlags = { ...state.uiFlags, ...uiFlags };
  },
  [types.CONTACT_SEARCH_SET_UI_FLAG](state, uiFlags) {
    state.uiFlags.contact = { ...state.uiFlags.contact, ...uiFlags };
  },
  [types.CONVERSATION_SEARCH_SET_UI_FLAG](state, uiFlags) {
    state.uiFlags.conversation = { ...state.uiFlags.conversation, ...uiFlags };
  },
  [types.MESSAGE_SEARCH_SET_UI_FLAG](state, uiFlags) {
    state.uiFlags.message = { ...state.uiFlags.message, ...uiFlags };
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
